module.exports = __webpack_public_path__ + "img/electro-city.e1cbb26c.png";